/* import __COLOCATED_TEMPLATE__ from './open-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import { type MacroAction } from 'embercom/objects/inbox/macro';

interface Signature {
  Args: { action: MacroAction };
}

const OpenConversation = templateOnlyComponent<Signature>();
export default OpenConversation;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UseMacro::Preview::OpenConversation': typeof OpenConversation;
    'inbox2/command-k/use-macro/preview/open-conversation': typeof OpenConversation;
  }
}
